export default "__VITE_ASSET__B6g9giYX__"